<template>
  <!-- eslint-disable -->
  <div class="medical-costs-wrapper">
    <div class="column-left">
      <SideNav />
    </div>

    <div class="column-right">
      <TopNav />
      <div class="main-container">
        <div v-if="loaded" class="medical-costs-container">
          <!-- Page Header -->
          <div class="page-header">
            <div class="header-content">
              <div class="title-section">
                <div class="page-icon" :style="{
                  backgroundImage: `linear-gradient(139deg, ${prestador.admin.assets.colors.primary} 0%, ${prestador.admin.assets.colors.secondary} 100%)`
                }">
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <circle cx="12" cy="12" r="10"></circle>
                    <path d="M16 8l-4 4 4 4"></path>
                    <path d="M8 12h8"></path>
                  </svg>
                </div>
                <div>
                  <h1 class="page-title">Costo por Servicios</h1>
                  <p class="page-subtitle">Configuración de tarifas y recargos para servicios domiciliarios</p>
                </div>
              </div>

              <div class="header-status">
                <div class="status-indicator" :class="{ 'editing': modificar_costos }">
                  <div class="status-dot"
                    :style="{ 'background-color': modificar_costos ? '#10b981' : prestador.admin.assets.colors.primary }">
                  </div>
                  <span class="status-text">{{ modificar_costos ? 'Modo Edición' : 'Solo Lectura' }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Service Costs Cards -->
          <div class="costs-grid">
            <!-- Base Service Cost Card -->
            <div class="cost-card">
              <div class="card-header">
                <div class="service-icon base-service">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                    <polyline points="9,22 9,12 15,12 15,22"></polyline>
                  </svg>
                </div>
                <div class="service-info">
                  <h3 class="service-title">Recargo Base</h3>
                  <p class="service-description">Costo fijo por orden de servicio domiciliario</p>
                </div>
                <div class="edit-action">
                  <button class="edit-btn" @click="toggleModificarCostosAndPost" :class="{ 'active': modificar_costos }"
                    :style="{
                      'color': !modificar_costos ? prestador.admin.assets.colors.primary : '#10b981',
                      'border-color': !modificar_costos ? prestador.admin.assets.colors.primary : '#10b981'
                    }">
                    <i :class="{ 'ti-pencil': !modificar_costos, 'ti-square-rounded-check': modificar_costos }"
                      class="menu-icon tf-icons ti"></i>
                  </button>
                </div>
              </div>

              <div class="card-content">
                <div class="cost-input-container">
                  <div class="currency-symbol">$</div>
                  <input v-model.number="costos.costo_servicio_base" type="number" class="cost-input"
                    :class="{ 'editable': modificar_costos }" :disabled="!modificar_costos" placeholder="0">

                  <div class="input-suffix">CLP</div>
                </div>
                <div class="cost-details">
                  <div class="detail-item">
                    <span class="detail-label">Tipo:</span>
                    <span class="detail-value">Costo fijo</span>
                  </div>
                  <div class="detail-item">
                    <span class="detail-label">Aplicación:</span>
                    <span class="detail-value">Por orden</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Variable Service Cost Card -->
            <div class="cost-card">
              <div class="card-header">
                <div class="service-icon variable-service">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                    <circle cx="12" cy="7" r="4"></circle>
                  </svg>
                </div>
                <div class="service-info">
                  <h3 class="service-title">Recargo Variable</h3>
                  <p class="service-description">Costo adicional por cada paciente atendido</p>
                </div>
                <div class="edit-action">
                  <button class="edit-btn" @click="toggleModificarCostosAndPost" :class="{ 'active': modificar_costos }"
                    :style="{
                      'color': !modificar_costos ? prestador.admin.assets.colors.primary : '#10b981',
                      'border-color': !modificar_costos ? prestador.admin.assets.colors.primary : '#10b981'
                    }">
                    <i :class="{ 'ti-pencil': !modificar_costos, 'ti-square-rounded-check': modificar_costos }"
                      class="menu-icon tf-icons ti"></i>
                  </button>
                </div>
              </div>

              <div class="card-content">
                <div class="cost-input-container">
                  <div class="currency-symbol">$</div>
                  <input v-model.number="costos.costo_servicio_variable" type="number" class="cost-input"
                    :class="{ 'editable': modificar_costos }" :disabled="!modificar_costos" placeholder="0">

                  <div class="input-suffix">CLP</div>
                </div>
                <div class="cost-details">
                  <div class="detail-item">
                    <span class="detail-label">Tipo:</span>
                    <span class="detail-value">Costo variable</span>
                  </div>
                  <div class="detail-item">
                    <span class="detail-label">Aplicación:</span>
                    <span class="detail-value">Por paciente</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Holiday Service Cost Card -->
            <div class="cost-card">
              <div class="card-header">
                <div class="service-icon holiday-service">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                    <line x1="16" y1="2" x2="16" y2="6"></line>
                    <line x1="8" y1="2" x2="8" y2="6"></line>
                    <line x1="3" y1="10" x2="21" y2="10"></line>
                    <path d="M8 14l2 2 4-4"></path>
                  </svg>
                </div>
                <div class="service-info">
                  <h3 class="service-title">Recargo Festivos</h3>
                  <p class="service-description">Costo adicional para servicios en días festivos</p>
                </div>
                <div class="edit-action">
                  <button class="edit-btn" @click="toggleModificarCostosAndPost" :class="{ 'active': modificar_costos }"
                    :style="{
                      'color': !modificar_costos ? prestador.admin.assets.colors.primary : '#10b981',
                      'border-color': !modificar_costos ? prestador.admin.assets.colors.primary : '#10b981'
                    }">
                    <i :class="{ 'ti-pencil': !modificar_costos, 'ti-square-rounded-check': modificar_costos }"
                      class="menu-icon tf-icons ti"></i>
                  </button>
                </div>
              </div>

              <div class="card-content">
                <div class="cost-input-container">
                  <div class="currency-symbol">$</div>
                  <input v-model.number="costos.costo_servicio_festivos" type="number" class="cost-input"
                    :class="{ 'editable': modificar_costos }" :disabled="!modificar_costos" placeholder="0">

                  <div class="input-suffix">CLP</div>
                </div>
                <div class="cost-details">
                  <div class="detail-item">
                    <span class="detail-label">Tipo:</span>
                    <span class="detail-value">Recargo especial</span>
                  </div>
                  <div class="detail-item">
                    <span class="detail-label">Aplicación:</span>
                    <span class="detail-value">Por fecha festiva</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Action Section -->
          <div class="action-section">
            <div class="action-card">
              <div class="action-header">
                <div class="action-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                    <circle cx="12" cy="10" r="3"></circle>
                  </svg>
                </div>
                <div class="action-info">
                  <h3 class="action-title">Configuración por Comuna</h3>
                  <p class="action-description">Personalizar costos específicos según ubicación geográfica</p>
                </div>
              </div>

              <div class="action-content">
                <button type="button" class="primary-action-btn"
                  :style="{ 'background-color': prestador.admin.assets.colors.primary }"
                  @click="$router.push({ name: 'ModificarCostoServicioComuna' })">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                  </svg>
                  Modificar Costo por Comuna
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Loading State -->
        <div v-else class="medical-costs-container">
          <div class="page-header">
            <div class="header-content">
              <div class="title-section">
                <div class="page-icon">
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <circle cx="12" cy="12" r="10"></circle>
                    <path d="M16 8l-4 4 4 4"></path>
                    <path d="M8 12h8"></path>
                  </svg>
                </div>
                <div>
                  <h1 class="page-title">Costo por Servicios</h1>
                  <p class="page-subtitle">Cargando configuración de tarifas...</p>
                </div>
              </div>
            </div>
          </div>

          <div class="loading-container">
            <div class="loading-card">
              <Loader :height="100" :width="100" />
              <p class="loading-text">Cargando información de costos...</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import axios from 'axios';
import { mapGetters } from 'vuex';
import SideNav from '@/components/SideNav.vue';
import Loader from '@/components/Loader.vue';
import TopNav from '@/components/TopNav.vue';

export default {
  name: 'HelloWorld',
  props: ['id'],
  components: {
    SideNav,
    Loader,
    TopNav,
  },
  data() {
    return {
      loaded: false,
      profesionales: [],
      costos: {
        costo_servicio_base: -1,
        costo_servicio_variable: -1,
        costo_servicio_festivos: -1,
      },
      modificar_costos: false,
    };
  },
  created() {
    this.get_costos_servicio();
  },
  methods: {
    get_costos_servicio() {
      this.loaded = false;
      axios.get(`${window.hostname}/api/admin/costo_servicio`)
        .then(response => {
          this.costos = response.data;

          this.costos.costo_servicio_base = this.costos.data.costo_servicio_base;
          this.costos.costo_servicio_variable = this.costos.data.costo_servicio_variable;
          this.costos.costo_servicio_festivos = this.costos.data.costo_servicio_festivos;

          this.loaded = true;
        })
        .catch(e => {
          this.loaded = true;
          console.log("Error al cargar costos servicios...", e);
        });
    },
    async post_costos_servicio() {
      if (this.modificar_costos) {
        const payload = {
          costo_servicio_base: Number(this.costos.costo_servicio_base) || 0,
          costo_servicio_variable: Number(this.costos.costo_servicio_variable) || 0,
          costo_servicio_festivos: Number(this.costos.costo_servicio_festivos) || 0,
        };

        try {
          await axios.post(`${window.hostname}/api/admin/costo_servicio`, payload);
          this.$notify({
            group: 'foo',
            title: '¡Costos cargados!',
            text: `Se han actualizado los costos correctamente`,
            type: 'success'
          });
          this.get_costos_servicio();
        } catch (e) {
          console.log("Error al enviar costos...", e);
        }
      }
    },
    toggleModificarCostosAndPost() {
      if (this.modificar_costos) {
        this.post_costos_servicio().then(() => {
          this.modificar_costos = !this.modificar_costos;
        });
      } else {
        this.modificar_costos = !this.modificar_costos;
      }
    },
    toggleModificarCostos() {
      this.modificar_costos = !this.modificar_costos;
    },
  },
  computed: {
    ...mapGetters(['comunas', 'categorias', 'regiones', 'prestaciones', 'tipos', 'admin_datos', 'prestador']),
  },
};
</script>

<style scoped>
/* Base Styles - Notion-inspired with medical touches */
.medical-costs-wrapper {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
}

.column-left {
  position: fixed;
  left: 0;
  top: 0;
  width: 280px;
  height: 100vh;
  z-index: 1000;
}

.column-right {
  margin-left: 280px;
  min-height: 100vh;
}

.main-container {
  padding: 0;
}

.medical-costs-container {
  padding: 2rem;
  max-width: 1400px;
  margin: 0 auto;
}

/* Page Header */
.page-header {
  background: white;
  border-radius: 16px;
  padding: 2rem;
  margin-bottom: 2rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);
  border: 1px solid #e2e8f0;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 2rem;
}

.title-section {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.page-icon {
  width: 64px;
  height: 64px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

.page-title {
  font-size: 2rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 0.5rem;
  letter-spacing: -0.025em;
}

.page-subtitle {
  font-size: 1.125rem;
  color: #64748b;
  margin: 0;
  font-weight: 400;
}

.header-status {
  display: flex;
  align-items: center;
}

.status-indicator {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 20px;
  transition: all 0.2s ease;
}

.status-indicator.editing {
  background: #f0fdf4;
  border-color: #bbf7d0;
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  transition: all 0.2s ease;
}

.status-text {
  font-size: 0.875rem;
  font-weight: 600;
  color: #64748b;
}

.status-indicator.editing .status-text {
  color: #166534;
}

/* Costs Grid */
.costs-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 2rem;
  margin-bottom: 2rem;
}

/* Cost Cards */
.cost-card {
  background: white;
  border: 2px solid #e2e8f0;
  border-radius: 16px;
  overflow: hidden;
  transition: all 0.3s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);
}

.cost-card:hover {
  border-color: #cbd5e1;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.07), 0 1px 3px rgba(0, 0, 0, 0.06);
  transform: translateY(-2px);
}

.card-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.5rem;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
}

.service-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.base-service {
  background: linear-gradient(135deg, #3b82f6, #1d4ed8);
}

.variable-service {
  background: linear-gradient(135deg, #10b981, #059669);
}

.holiday-service {
  background: linear-gradient(135deg, #f59e0b, #d97706);
}

.service-info {
  flex: 1;
}

.service-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1e293b;
  margin: 0 0 0.25rem;
}

.service-description {
  font-size: 0.875rem;
  color: #64748b;
  margin: 0;
}

.edit-action {
  display: flex;
  align-items: center;
}

.edit-btn {
  width: 44px;
  height: 44px;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 18px;
}

.edit-btn:hover {
  background-color: rgba(59, 130, 246, 0.05);
  transform: scale(1.05);
}

.edit-btn.active {
  background-color: rgba(16, 185, 129, 0.1);
  border-color: #10b981;
}

/* Card Content */
.card-content {
  padding: 1.5rem;
}

.cost-input-container {
  display: flex;
  align-items: center;
  background: #f8fafc;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  padding: 0.75rem 1rem;
  margin-bottom: 1.5rem;
  transition: all 0.2s ease;
}

.cost-input-container:focus-within {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  background: white;
}

.currency-symbol {
  font-size: 1.25rem;
  font-weight: 600;
  color: #64748b;
  margin-right: 0.5rem;
}

.cost-input {
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  font-size: 1.5rem;
  font-weight: 700;
  color: #1e293b;
  padding: 0.25rem 0;
}

.cost-input:disabled {
  color: #64748b;
}

.cost-input.editable {
  color: #059669;
}

.input-suffix {
  font-size: 0.875rem;
  font-weight: 600;
  color: #94a3b8;
  margin-left: 0.5rem;
}

.cost-details {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.detail-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.detail-label {
  font-size: 0.875rem;
  color: #64748b;
  font-weight: 500;
}

.detail-value {
  font-size: 0.875rem;
  color: #1e293b;
  font-weight: 600;
}

/* Action Section */
.action-section {
  margin-top: 2rem;
}

.action-card {
  background: white;
  border: 2px solid #e2e8f0;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);
}

.action-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.5rem;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
}

.action-icon {
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, #8b5cf6, #7c3aed);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  box-shadow: 0 2px 4px rgba(139, 92, 246, 0.2);
}

.action-info {
  flex: 1;
}

.action-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1e293b;
  margin: 0 0 0.25rem;
}

.action-description {
  font-size: 0.875rem;
  color: #64748b;
  margin: 0;
}

.action-content {
  padding: 1.5rem;
}

.primary-action-btn {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  background: linear-gradient(135deg, #3b82f6, #1d4ed8);
  color: white;
  border: none;
  padding: 1rem 2rem;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(59, 130, 246, 0.2);
  width: 100%;
  justify-content: center;
}

.primary-action-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(59, 130, 246, 0.3);
}

/* Loading State */
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
}

.loading-card {
  background: white;
  border-radius: 16px;
  padding: 3rem;
  text-align: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);
  border: 1px solid #e2e8f0;
}

.loading-text {
  margin-top: 1.5rem;
  font-size: 1rem;
  color: #64748b;
  font-weight: 500;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .column-right {
    margin-left: 0;
  }

  .medical-costs-container {
    padding: 1rem;
  }

  .costs-grid {
    grid-template-columns: 1fr;
  }

  .header-content {
    flex-direction: column;
    align-items: stretch;
    gap: 1.5rem;
  }
}

@media (max-width: 768px) {
  .medical-costs-container {
    padding: 0.5rem;
  }

  .page-header {
    padding: 1.5rem;
  }

  .title-section {
    flex-direction: column;
    text-align: center;
    gap: 1rem;
  }

  .page-icon {
    width: 48px;
    height: 48px;
  }

  .page-title {
    font-size: 1.5rem;
  }

  .page-subtitle {
    font-size: 1rem;
  }

  .costs-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .card-header {
    flex-direction: column;
    text-align: center;
    gap: 1rem;
  }

  .cost-input {
    font-size: 1.25rem;
  }
}

@media (max-width: 480px) {
  .medical-costs-container {
    padding: 0.25rem;
  }

  .page-header {
    padding: 1rem;
  }

  .card-content {
    padding: 1rem;
  }

  .action-content {
    padding: 1rem;
  }

  .cost-input {
    font-size: 1.125rem;
  }

  .primary-action-btn {
    padding: 0.875rem 1.5rem;
    font-size: 0.875rem;
  }
}

/* Focus States */
.cost-input:focus,
.edit-btn:focus,
.primary-action-btn:focus {
  outline: 2px solid #3b82f6;
  outline-offset: 2px;
}

/* High Contrast Mode */
@media (prefers-contrast: high) {

  .cost-card,
  .action-card {
    border-width: 2px;
  }

  .cost-input-container {
    border-width: 2px;
  }

  .edit-btn {
    border-width: 2px;
  }
}

/* Reduced Motion */
@media (prefers-reduced-motion: reduce) {

  .cost-card,
  .cost-input-container,
  .edit-btn,
  .primary-action-btn,
  .status-indicator,
  .status-dot {
    transition: none;
  }
}

/* Dark mode support (if needed) */
@media (prefers-color-scheme: dark) {
  .medical-costs-wrapper {
    background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
  }

  .cost-card,
  .action-card,
  .page-header,
  .loading-card {
    background: #1e293b;
    border-color: #334155;
  }

  .card-header,
  .action-header {
    background: #0f172a;
    border-bottom-color: #334155;
  }

  .page-title,
  .service-title,
  .action-title,
  .cost-input,
  .detail-value {
    color: #e2e8f0;
  }

  .page-subtitle,
  .service-description,
  .action-description,
  .detail-label,
  .status-text,
  .loading-text {
    color: #94a3b8;
  }

  .cost-input-container,
  .detail-item {
    background: #0f172a;
    border-color: #334155;
  }

  .cost-input:disabled {
    color: #94a3b8;
  }
}
</style>